import React, { useEffect, useState } from "react";
import * as S from "./SurveyFrecuency.style";
import { useTranslation } from "react-i18next";
import * as P from "../../../../../../../utils/pipes";

import ZaiaSelect from "../../../../../../zaiaComponents/zaiaSelect";
import ZaiaInput from "../../../../../../zaiaComponents/zaiaInput";
import ZaiaToggleCircular from "../../../../../../zaiaComponents/zaiaToggleCircular";
import FlorenzSelect from "../../../../../../florenzComponents/florenzSelect";
import FlorenzInputDate from "../../../../../../florenzComponents/florenzInputDate";
import CalendarRange from "../surveyRange/calendarRange";


function SurveyFrecuency({
  selectedWithFrequency,
  selectedInterval,
  selectedReminderHour,
  selectedRangeStart,
  selectedRangeFinish,
  changeFormField,
  frequenciesList,
  goNextInput,
}) {

  const { t } = useTranslation("global");

  const [initialDate, setInitialDate] = useState();
  const [finishDate, setFinishDate] = useState();

  const [disableFinishDate, setDisableFinishDate] = useState(false);

  function getLocalDate() {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    return today.toISOString().split('T')[0];
  }

  const saveDates = async () => {
      if(initialDate && finishDate) {
        changeFormField(
          [
            {
              value: P.formatNumberDateInput(initialDate), 
              text: ", " + P.formatNumberDate(initialDate, true),
              fieldName: "rangeStart",
            },
            {
              value: P.formatNumberDateInput(finishDate), 
              text: " - " + P.formatNumberDate(finishDate, true), 
              fieldName: "rangeFinish",
            }
          ]
        )
      } else if (initialDate) {
          changeFormField(
            [
              {
                value: P.formatNumberDateInput(initialDate), 
                text: P.formatNumberDate(initialDate, true),
                fieldName: "rangeStart",
              },
              {
                value: disableFinishDate ? true : null, 
                text: "", 
                fieldName: "rangeFinish",
              }
            ]
          )
        } else {
          if(!selectedRangeStart.value && !selectedRangeFinish.value) {
            changeFormField(
              [
                {
                  value: null, 
                  text: "",
                  fieldName: "rangeStart",
                },
                {
                  value: null, 
                  text: "", 
                  fieldName: "rangeFinish",
                }
              ]
            )
            setInitialDate(null);
            setFinishDate(null);
          } else {
            setInitialDate(new Date(selectedRangeStart.value.replace(/-/g,'/').replace('T',' ')));
            setFinishDate(new Date(selectedRangeFinish.value.replace(/-/g,'/').replace('T',' ')));
          }
      }
    }
  
    useEffect(() => {
      saveDates();    
    }, [initialDate, finishDate])

    useEffect(() => {
      changeFormField(
        [
          {
            value: null, 
            text: "",
            fieldName: "rangeStart",
          },
          {
            value: null, 
            text: "", 
            fieldName: "rangeFinish",
          }
        ]
      )
      setInitialDate(null);
      setFinishDate(null);
    }, [disableFinishDate])

  return (
    <S.SurveyFrecuency>
      <div className="doseage-inputs">
        <div className="input-toogle">
          <div className="input-toogle__text">{t("surveys.sendSurveyModal.withoutFrequency")}</div>
          <div className="input-toogle__toogle">
            <ZaiaToggleCircular
              id={'patient-alert-toggle'}
              color={"#27AE60"}
              toggle={(e) => {
                changeFormField(
                  [
                    {
                      value: !e, 
                      text: "", 
                      fieldName: "withFrequency"
                    },
                    {
                      value: null, 
                      text: "", 
                      fieldName: "interval"
                    },
                    {
                      value: selectedWithFrequency.value ? "" : null, 
                      text: "", 
                      fieldName: "rangeStart"
                    },
                    {
                      value: selectedWithFrequency.value ? "" : null,  
                      text: "", 
                      fieldName: "rangeFinish"
                    }
                  ]
                )
              }}
              active={!selectedWithFrequency.value}
            />
          </div>
        </div>
        {
          selectedWithFrequency.value &&
          <div className="input-space">
            <FlorenzSelect
              xsSize={true} 
              forWhiteBackgroud={true}
              items={frequenciesList}
              value={selectedInterval.value}
              label={t("globally.chooseInterval")}
              placeholder={t("globally.recieveNotificationEveryDay")}              
              setValue={(value) => 
                changeFormField(  
                  [
                    {
                      value: value, 
                      text: frequenciesList.find((frequency) => frequency.value === value).text + ", ", 
                      fieldName: "interval"
                    }
                  ]
                )
              } 
              heightList={"200px"}
              required
            />
          </div>
        }
        {
          !selectedWithFrequency.value &&
          <div className="input-space input-space--dose">
            <FlorenzInputDate
              label={t("surveys.sendSurveyModal.chooseSendDate")}
              value={selectedInterval.value ?? ""}
              getText={(e) => {
                if(e) {
                  if(new Date(e) < new Date(getLocalDate())) {
                    changeFormField(
                      [
                        {
                          value: getLocalDate(), 
                          text: getLocalDate() + " ", 
                          fieldName: "interval"
                        }
                      ]
                    )
                  } else {
                    changeFormField(
                      [
                        {
                          value: e, 
                          text: e + " ", 
                          fieldName: "interval"
                        }
                      ]
                    )
                  }
                } else {
                  changeFormField(
                    [
                      {
                        value: null, 
                        text: "", 
                        fieldName: "interval"
                      }
                    ]
                  )
                }
              }}
              type="date"
              required
            />
          </div>
        }
        <div className="input-space">
          <FlorenzInputDate
            label={t("surveys.sendSurveyModal.reminderHour")}
            value={selectedReminderHour.value ?? ""}
            time={true}
            getText={(value) => {
              changeFormField(
                [
                  {
                    value: value, 
                    text: value, 
                    fieldName: "reminderHour"
                  }
                ]
              )
              goNextInput()
            }
            }
            type="date"
            required
          />
        </div>
      </div>
      {
        selectedWithFrequency.value &&
        <S.SurveyRange>
          <div className="title">
            {t("globally.chooseInitialDate")}
          </div>
          <div className="calendar-inputs">
            <div className="input-container">
              <div className="input-label">{t("globally.initial")}</div>
              <div className="input-container__box">
                <ZaiaInput 
                  type={"date"}
                  name="data"
                  errorOption={false}
                  getText={(e) => {
                    setInitialDate(new Date(e));
                    // setInitialDate(new Date(e.replace(/-/g,'/').replace('T',' ')));
                  }}
                  disabled={true}
                  value={selectedRangeStart.value ? selectedRangeStart.value : ""}
                  padding={"5px 10px"}
                  borderRadius={"4px"}
                  textColor={"#6C6BCC"}
                  borderColor={"transparent"}
                  fontSize="15px"
                  />
              </div>
            </div>
            <div className={`input-container ${disableFinishDate && "input-container--unfocus"}`}>
              <div className="input-label">{t("globally.final")}</div>
              <div className="input-container__box">
                <ZaiaInput
                  type={"date"}
                  name="data"
                  errorOption={false}
                  getText={(e) => {
                    setFinishDate(new Date(e.replace(/-/g,'/').replace('T',' ')));
                    // setFinishDate(new Date(e.replace(/-/g,'/').replace('T',' ')));
                  }}
                  disabled={true}
                  value={selectedRangeFinish.value ? selectedRangeFinish.value : ""}
                  padding={"5px 10px"}
                  borderRadius={"4px"}
                  textColor={"#6C6BCC"}
                  borderColor={"transparent"}
                  placeholdertextcolor={"#878792"}
                  fontSize="15px"
                  />
              </div>
            </div>
          </div>
          <div className="calendar-range-container">
            <div className="calendar-range">
              <CalendarRange
                initialDate={initialDate}
                finishDate={finishDate}
                setInitialDate={setInitialDate}
                setFinishDate={setFinishDate}
                rangeActive={!disableFinishDate}
                titleColor={"#37358F"}
                arrowsColor={"#37358F"}
                textColor={"#6A6898"}
                dateSelectedPrimaryColor={"#37358F"}
                dateSelectedSecondColor={"#37358F"}
                currentDayColor={"#37358F"}
                fontSizeCalendar={"8px"}
              />
            </div>
          </div>
          <div className="toogle-container">
            <span>{t("globally.withoutEndDate")}</span>
            <ZaiaToggleCircular
              id={'end-date-toggle'}
              color={"#37358F"}
              toggle={setDisableFinishDate}
              active={disableFinishDate}
            />
          </div>
        </S.SurveyRange>
      }
    </S.SurveyFrecuency>
  );
}

export default SurveyFrecuency;
